import React, { Component } from 'react'
import Mesh from 'aria-viewer/players/three/Mesh'
import * as THREE from 'three'
import { dispose3DObject } from '../../../utils'

class Text3D extends Component {
    constructor(props) {
        super(props)
        this.initialPositionCreated
        this.parallaxDisplacement
    }

    state = {
        material: null,
        geometry: new THREE.PlaneGeometry(0, 0, 0),
        obj: null,
    }

    handleTextLength = geometry => {
        geometry.computeBoundingBox()
        return geometry.boundingBox
    }

    componentDidMount() {
        const { textColor } = this.props
        var material = new THREE.MeshBasicMaterial({ color: textColor })
        this.setState({
            material,
        })
    }

    componentDidUpdate(prevProps) {
        const { isVisible, handleReveal, handleHide } = this.props
        const { obj } = this.state
        // Toggles on hover and on exit via controlled prop
        // Allow for non-controlled option?
        if (!prevProps.isVisible && isVisible) {
            handleReveal && handleReveal(obj)
        } else if (prevProps.isVisible && !isVisible) {
            handleHide && handleHide(obj)
        }
    }

    onMeshMount = obj => {
        const {
            text,
            fontResource,
            size,
            height,
            rootObj,
            createAnimations,
            relativePosition,
            handleInitialReveal,
            handleInitialHide,
            isVisible,
            boxWidth,
            shortenedTextLength,
        } = this.props
        var loader = new THREE.FontLoader()
        loader.crossOrigin = ''

        // Asynchronously loads font description resource
        loader.load(fontResource, font => {
            // Creates geometry from font
            var geometry = new THREE.TextBufferGeometry(text, {
                font,
                size,
                height,
                curveSegments: 12,
                bevelEnabled: false,
            })

            var testLength = this.handleTextLength(geometry)
            if (testLength.max.x - testLength.min.x > boxWidth) {
                // Creates geometry from font
                // https://stackoverflow.com/questions/18038896/how-do-i-make-a-textgeometry-multiline-how-do-i-put-it-inside-a-square-so-it-wr
                // Get first 3 words if text is too long
                geometry = new THREE.TextBufferGeometry(
                    text
                        .split(' ')
                        .slice(0, shortenedTextLength)
                        .join(' ') + '...',
                    {
                        font,
                        size,
                        height,
                        curveSegments: 12,
                        bevelEnabled: false,
                    }
                )
            }
            // Sets on object
            obj.geometry = geometry

            // Sets position based on passed in offset.  Defaults to origin of root
            obj.position.set(relativePosition.x, relativePosition.y, relativePosition.z)

            // Set to allow for opacity to work
            obj.material.transparent = true
            obj.material.opacity = 0

            // Add to root object
            rootObj.add(obj)

            // Rig up animations in HOC
            createAnimations && createAnimations(obj)

            // Triggers reveal animation of callback given, otherwise sets opacity to 1.  Only if isVisible prop is true
            if (isVisible) {
                handleInitialReveal(obj)
            } else {
                handleInitialHide(obj)
            }

            // Sets resources on state
            this.setState({ obj, geometry })

            // Kicks off animation loop
            this.animate()
        })
    }

    onMeshUnmount = () => {
        const { rootObj } = this.props
        const { obj } = this.state
        this.raf && cancelAnimationFrame(this.raf)
        this.domEvents && this.domEvents.destroy()
        dispose3DObject(obj)
        rootObj.remove(obj)
        this.setState({ obj: null, geometry: null, material: null })
    }

    animate = () => {
        const { rootObj, relativePosition, faceCamera, parallax, parallaxDisplacementCofactor = 0.25 } = this.props
        const { obj } = this.state
        // Camera quaternion copy doesn't work.  Need to look at origin
        // Avoids looking directly in the origin to avoid slanting as text move towards the center
        if (faceCamera) {
            obj && obj.lookAt(new THREE.Vector3(0, rootObj.position.y + relativePosition.y, 0))
        }

        // To do: call programatically on keys in materialOverrides to map to material
        // obj.material.opacity = opacity

        //To do: call programmatically on keys in mesh to map to material
        // if (isVisible) {
        // let parallaxDisplacement = 0
        // To do: Think of a better way to compose effects that alter shared attribute, i.e., position
        // if (parallax) {
        // let target = new THREE.Vector3()
        // camera.getWorldDirection(target)
        // Calculates a parallax displacement with a cap at parallaxDisplacementCofactor
        // Would be nice to allow parallax to be dependent on absolute distance from camera
        // But easier to let it be specified with cofactor value
        //     parallaxDisplacement =
        //         Math.abs(parallaxDisplacementCofactor * target.y) < parallaxDisplacementCofactor
        //             ? parallaxDisplacementCofactor * target.y
        //             : (target.y / Math.abs(target.y)) * parallaxDisplacementCofactor
        // }
        // obj.position.set(
        //     this.initialPosition.x,
        //     // Move this out of here '2*this.initialPosition.y' out of here.  Should not have intro animation baked into text
        //     2 * this.initialPosition.y - this.initialPosition.y * position.y + parallaxDisplacement,
        //     this.initialPosition.z
        // )
        // obj.position.set(rootObj.position.x, rootObj.position.y, rootObj.position.z)
        // }

        this.raf = requestAnimationFrame(this.animate)
    }

    render() {
        const { material, geometry } = this.state

        return material && geometry ? (
            <Mesh
                geometry={geometry}
                material={material}
                onMount={this.onMeshMount}
                onWillUnmount={this.onMeshUnmount}
            />
        ) : null
    }
}

Text3D.defaultProps = {
    relativePosition: {
        x: 0,
        y: 0,
        z: 0,
    },
    textColor: 'white',
    faceCamera: true,
    isVisible: false,
    handleInitialReveal: obj => {
        obj.material.opacity = 1
    },
    handleInitialHide: obj => {
        obj.material.opacity = 0
        Object.assign(obj.scale, new THREE.Vector3(0.00001, 0.00001, 0.00001))
    },
    fontResource:
        'https://raw.githubusercontent.com/rollup/three-jsnext/master/examples/fonts/helvetiker_regular.typeface.json',
    size: 1,
    height: 0.1,
    boxWidth: 1,
    shortenedTextLength: 3,
}

export default Text3D
